import Vue from "vue"
import {calendar_api} from "../resources"

export default {
    namespaced: true,
    state: {
        transactions: {
            data: [],
            dirty: false,
            pagination: {
                current_page: null,
                pages: null
            }
        },
    },
    getters: {
        transactions: state => state.transactions.data,
        transactionsByDate: state => {
            const transactionsByDate = {}
            state.transactions.data.forEach(item => {
                const date = Vue.prototype.$moment(item.date, 'YYYY-MM-DD').startOf('day').format('DD-MM-YYYY');
                if (!transactionsByDate[date]) transactionsByDate[date] = []
                transactionsByDate[date].push(item);
            })
            return transactionsByDate;
        }
    },
    actions: {
        async getPlannedTransactions({commit, rootState, state}) {
            if (!state.transactions.data.length) {
                commit('setPlannedTransactionsDirty');
            }
            commit('setPagePlannedTransactions', 1);
            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date_end: Vue.prototype.$moment().add(3, 'day').format('YYYY-MM-DD'),
                    'per-page': 3,
                    page: state.transactions.pagination.current_page
                };
                const res = await calendar_api.plannedTransactions.get(query)
                if (res.body.success) {
                    commit('setPlannedTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async loadMorePlannedTransactions({commit, rootState, state}) {
            try {
                const query = {
                    space_id: rootState.space.current_space.data.id,
                    date_end: Vue.prototype.$moment().add(3, 'day').format('YYYY-MM-DD'),
                    'per-page': 3,
                    page: state.transactions.pagination.current_page
                };
                const res = await calendar_api.plannedTransactions.get(query)
                if (res.body.success) {
                    commit('pushPlannedTransactions', res.body);
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        setPlannedTransactionsDirty(state) {
            state.transactions.dirty = true
        },
        setPlannedTransactions(state, body) {
            state.transactions.data = body.data.rows;
            state.transactions.pagination.pages = Math.ceil(body.data.length / 3);
            state.transactions.dirty = false;
        },
        pushPlannedTransactions(state, body) {
            state.transactions.data.push(...body.data.rows)
        },
        setPagePlannedTransactions(state, num) {
            state.transactions.pagination.current_page = num;
        },
        clearPlannedTransactions(state) {
            state.transactions = {
                data: [],
                dirty: false,
                total_data: null,
                pagination: {
                    current_page: null,
                    pages: null
                }
            }
        }
    }
}
